import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDetections = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1 0.25H0.25V1V5H1.75V1.75H5V0.25H1ZM13 1.75H16.25V5H17.75V1V0.25H17H13V1.75ZM1.75 13V16.25H5V17.75H1H0.25V17V13H1.75ZM16.25 13V16.25H13V17.75H17H17.75V17V13H16.25ZM6.25 9.75H8.25V11.75H6.25V9.75ZM4.75 8.25H0.25V9.75H4.75V12.5V13.25H5.5H8.25L8.25 17.75H9.75V13.25H12.5H13.25V12.5V9.75H17.75V8.25H13.25V5.5V4.75H12.5H9.75V0.25H8.25L8.25 4.75H5.5H4.75V5.5V8.25ZM6.25 8.25V6.25H8.25V8.25H6.25ZM9.75 6.25V8.25H11.75V6.25H9.75ZM11.75 9.75H9.75V11.75H11.75V9.75Z",
		fill: "currentColor"
	})
});
export default SvgDetections;
